import React, {FC, useEffect, useState} from 'react';
import './view.styles.css';
import {PropsType} from "./view.types";
import {UpdateMovieType} from "./local_state/reducer.types";

let dataout: string | undefined = undefined

const ParseNewFilmsView: FC<PropsType> = ({
      currentRow,
      setList,
      processRow,
      downloadList,
      uploadFilm,
      skip,
   }: PropsType) => {

    const [row, setRow] = useState<UpdateMovieType>(currentRow)
    const [filmaCustomId, setFilmaCustomId] = useState<string>(currentRow.filmaffinityResult?.id || '')
    const [imdbCustomId, setImdbCustomId] = useState<string>(currentRow.imdbResult?.id || '')
    const [audioCustom, setAudioCustom] = useState<string>(currentRow.audio || '')
    const [subsCustom, setSubsCustom] = useState<string>(currentRow.subs || '')

    useEffect(() => {
        console.log('useEffect')
        console.log(currentRow)
        if (row.md5 !== currentRow.md5) {
            processRow(currentRow)
            setAudioCustom(currentRow.audio || '')
            setSubsCustom(currentRow.subs || '')
        }
        setRow(currentRow)
        setFilmaCustomId(currentRow.filmaffinityResult?.id || '')
        setImdbCustomId(currentRow.imdbResult?.id || '')
    }, [currentRow])

    function onSubmit(){
        uploadFilm({
            ...currentRow,
            filmaffinityResult: {
                id: filmaCustomId
            },
            imdbResult: {
                id: imdbCustomId
            },
            audio: audioCustom,
            subs: subsCustom
        })
    }

    function onSkip(){
        skip()
    }

    return (
        <div className="App">
            <input
                type="file"
                onChange={(e) => {
                    if (e?.target?.files) {
                        const fileReader = new FileReader();
                        fileReader.onloadend = (_e) => {
                            const content = fileReader.result;
                            if (content) {
                                setList(content.toString())
                            }
                        }
                        fileReader.readAsText(e?.target?.files[0])
                    }
                }}
            />
            <div>
                AUDIO:
                <input type={'text'}
                       placeholder={'audio'}
                       value={audioCustom}
                       onChange={(e) => {
                           setAudioCustom(e.target.value)
                       }}/>
                SUBS:
                <input type={'text'}
                       placeholder={'subs'}
                       value={subsCustom}
                       onChange={(e) => {
                           setSubsCustom(e.target.value)
                       }}/>
            </div>
            <div>
                {currentRow.imdbResult?.title || ''}
                <br/>
                <a href={currentRow.imdbResult?.url || ''} target={'_blank'} rel="noreferrer">{currentRow.imdbResult?.url || ''}</a>
                <br/>
                {currentRow.filmaffinityResult?.title || ''}
                <br/>
                <a href={currentRow.filmaffinityResult?.url || ''} target={'_blank'} rel="noreferrer">{currentRow.filmaffinityResult?.url || ''}</a>
                <br/>
                <input type={'text'}
                       placeholder={'filmaffinity'}
                       value={filmaCustomId}
                       onChange={(e) => {
                           setFilmaCustomId(e.target.value)
                       }}/>
                <input type={'text'}
                       placeholder={'imdb'}
                       value={imdbCustomId}
                       onChange={(e) => {
                           setImdbCustomId(e.target.value)
                       }}/>
            </div>

            <div>
            </div>
            <div>
                <img style={{ width: 100, height: 200 }} src={currentRow.imdbResult?.image}/>
                <img style={{ width: 100, height: 200 }} src={currentRow.filmaffinityResult?.image}/>
            </div>
            <button onClick={onSubmit}>Submit and Next</button>
            <button onClick={onSkip}>Skip</button>
            <button onClick={() => downloadList(dataout)}>Download</button>
            <p>{JSON.stringify(currentRow)}</p>
        </div>
    );
}

export default ParseNewFilmsView;
